module.exports = __webpack_public_path__ + "static/media/8440.c9c47df9.jpg";